module.exports = {

  home: 'Home',
  csvWordsAnalyzer: 'CSV words analyzer',
  csvAdsAnalyzer: 'CSV ads analyzer',

  accountSettings: 'Account Settings',
  logout: 'Sign out',

  help: 'Help'

}


// WEBPACK FOOTER //
// ../i18n/en/menu.js